import { render, staticRenderFns } from "./PolicyClauses.vue?vue&type=template&id=6dfe67d8&scoped=true"
import script from "./PolicyClauses.vue?vue&type=script&lang=js"
export * from "./PolicyClauses.vue?vue&type=script&lang=js"
import style0 from "./PolicyClauses.vue?vue&type=style&index=0&id=6dfe67d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfe67d8",
  null
  
)

export default component.exports